import Skeleton from "@mui/material/Skeleton"
import { styled } from "@mui/material/styles"

export default function GlossaryListSkeleton() {
    const items = Array.from({ length: 100 }).map((_, i) => ({ key: i }))
    return (
        <StyledRemainingList>
            {items.map(i => (
                <Skeleton
                    key={i.key}
                    height={27}
                    width={175}
                />
            ))}
        </StyledRemainingList>
    )
}

const StyledRemainingList = styled("ul")(({ theme }) => ({
    columnCount: 4,
    gap: theme.spacing(1),
    listStyle: "none",
    [theme.breakpoints.down("md")]: {
        columnCount: 2
    },
    [theme.breakpoints.down("sm")]: {
        columnCount: 1
    }
}))
